import { render } from "./PaymentInitial.vue?vue&type=template&id=6da18c53"
import script from "./PaymentInitial.vue?vue&type=script&lang=js"
export * from "./PaymentInitial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__